module.exports = __webpack_public_path__ + "media/images/img_recommend_01-51c2b54109ef306517f2b20f89ad4c2f.png";